/**
 * mcycle homepage header
 * @Create jiangbao(jiangbao1123@gmail.com)
 * @CreateDate  2017/12/7
 */
import './index.css';
import React, { Component } from 'react';
import Banner from './banner/banner';
import BottomBar from './bottomBar/bottomBar';
import SearchBox from './searchBox/searchBox';
import FreePost from '../../../svgs/freePost';
import Check from '../../../svgs/check';
import Secret from '../../../svgs/secret';
import Subsidy from '../../../svgs/subsidy';
import Deduction from '../../../svgs/deduction';

class Header extends Component {
  /**
   * bottom bar model
   */
  bannerList = [{
    icon: <FreePost />,
    text: '全国包邮'
  }, {
    icon: <Check />,
    text: '专业检测'
  }, {
    icon: <Secret />,
    text: '隐私保护'
  }, {
    icon: <Subsidy />,
    text: '魅族换新补贴'
  }, {
    icon: <Deduction />,
    text: '商城消费抵扣'
  }];

  /**
   * cycle flow model
   */
  flowList = [{
    title: '1',
    text: '在线估值'
  }, {}, {
    title: '2',
    text: '免费寄件'
  }, {}, {
    title: '3',
    text: '专业检测'
  }, {}, {
    title: '4',
    text: '发放回购金'
  }]

  render() {
    return (
      <div className="mcycle-home-header">
        <Banner />
        <BottomBar bannerList={ this.bannerList } />
        <SearchBox flowList={ this.flowList } />
      </div>
    )
  }
}

export default Header


// WEBPACK FOOTER //
// ./src/components/home/header/index.js